module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2n7r4n-d46628b6a66e0def5caf5736ac3a58e9.svg";